export default "__VITE_ASSET__DMdHKN62__"